import { Button } from "../components/ui/button";
import { Star, Check, Quote } from "lucide-react";

const AFFILIATE_URL = "https://bc072hg2p7rncg20qs5ev03po2.hop.clickbank.net";

export const Testimonials = () => {
  const testimonials = [
    {
      name: "Tasha M.",
      age: 41,
      location: "Austin, TX",
      image: "https://images.unsplash.com/photo-1590905775253-a4f0f3c426ff?w=200",
      quote: "I tried this on a whim. I've tried powders, shakes, and all the latest trends, but I wasn't expecting much. Within a week, I noticed my jeans were looser and my energy was stable all day. No jitters, no weird side effects. Just calm, steady progress. I've lost 22 pounds and feel in control for the first time in years.",
      rating: 5,
      result: "Lost 22 lbs",
      verified: true,
    },
    {
      name: "Neil C.",
      age: 57,
      location: "Asheville, NC",
      image: "https://images.unsplash.com/photo-1609521694362-43c2030111ba?w=200",
      quote: "The late-night eating was killing me. This made the difference almost immediately. I'm not constantly thinking about food anymore. I've dropped 17 pounds, my doctor noticed my improved overall wellness markers, and I'm not falling asleep at my desk by 3pm. It's subtle, but powerful. I feel younger than I have in a decade.",
      rating: 5,
      result: "Lost 17 lbs",
      verified: true,
    },
    {
      name: "Elizabeth V.",
      age: 62,
      location: "Boise, ID",
      image: "https://images.unsplash.com/photo-1702648159730-00699257be79?w=200",
      quote: "I used to wake up foggy, bloated, and dragging myself through the day. Now, I take this with water when I wake up and within 30 minutes I'm moving with purpose. I've lost 14 pounds, but more than that, I'm back to being the version of myself I actually like.",
      rating: 5,
      result: "Lost 14 lbs",
      verified: true,
    },
  ];

  return (
    <section id="testimonials" data-testid="testimonials-section" className="py-16 md:py-20 bg-[#F9F7F2]" aria-labelledby="testimonials-heading">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <a href={AFFILIATE_URL} target="_blank" rel="noopener noreferrer" className="block">
          <div className="text-center mb-12 cursor-pointer">
            <span className="inline-block bg-[#FFF5E6] text-[#FF6B00] text-xs font-bold px-4 py-1.5 rounded-full mb-4 uppercase tracking-wider">
              Real Results
            </span>
            <h2 id="testimonials-heading" className="text-3xl md:text-4xl lg:text-5xl font-black text-[#1A1C19] mb-4" style={{ fontFamily: "Fraunces, serif" }}>
              Real <span className="text-[#FF6B00]">"Orange Peel Trick"</span> Users
            </h2>
            <p className="text-lg text-[#4A5043] max-w-2xl mx-auto">
              Real life-changing results from verified customers
            </p>
          </div>
        </a>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
          {testimonials.map((testimonial, index) => (
            <a key={index} href={AFFILIATE_URL} target="_blank" rel="noopener noreferrer" className="block">
              <article
                data-testid={`testimonial-card-${index}`}
                className="bg-white rounded-2xl p-6 shadow-lg border border-[#FFE4CC] relative cursor-pointer hover:shadow-xl transition-shadow h-full"
              >
                {/* Quote Icon */}
                <div className="absolute -top-3 left-6 w-8 h-8 bg-[#FF6B00] rounded-full flex items-center justify-center" aria-hidden="true">
                  <Quote size={16} className="text-white" fill="white" />
                </div>

                {/* Result Badge */}
                <div className="absolute -top-3 right-6 bg-[#2E7D32] text-white text-xs font-bold px-3 py-1 rounded-full">
                  {testimonial.result}
                </div>

                <div className="flex items-center gap-4 mt-4 mb-4">
                  <img
                    src={testimonial.image}
                    alt={`${testimonial.name}, age ${testimonial.age} from ${testimonial.location} - verified customer who ${testimonial.result.toLowerCase()}`}
                    className="w-14 h-14 rounded-full object-cover border-2 border-[#FF6B00]"
                    loading="lazy"
                  />
                  <div>
                    <p className="font-bold text-[#1A1C19]">{testimonial.name}</p>
                    <p className="text-xs text-[#73786F]">Age {testimonial.age} • {testimonial.location}</p>
                  </div>
                </div>

                <div className="flex items-center gap-0.5 mb-3" role="img" aria-label={`${testimonial.rating} out of 5 stars`}>
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} size={14} fill="#FF6B00" className="text-[#FF6B00]" aria-hidden="true" />
                  ))}
                </div>

                <blockquote className="text-[#4A5043] text-sm leading-relaxed mb-4">"{testimonial.quote}"</blockquote>

                {testimonial.verified && (
                  <div className="flex items-center gap-2 text-xs text-[#2E7D32]">
                    <Check size={14} aria-hidden="true" />
                    <span className="font-medium">Verified Purchase</span>
                  </div>
                )}
              </article>
            </a>
          ))}
        </div>

        {/* Overall Rating - Clickable */}
        <a href={AFFILIATE_URL} target="_blank" rel="noopener noreferrer" className="block">
          <div className="bg-white rounded-2xl p-6 shadow-lg border border-[#FFE4CC] max-w-md mx-auto text-center mb-10 cursor-pointer hover:shadow-xl transition-shadow">
            <div className="flex items-center justify-center gap-1 mb-2" role="img" aria-label="4.9 out of 5 stars">
              {[...Array(5)].map((_, i) => (
                <Star key={i} size={24} fill="#FF6B00" className="text-[#FF6B00]" aria-hidden="true" />
              ))}
            </div>
            <p className="text-2xl font-black text-[#1A1C19]">4.9 out of 5</p>
            <p className="text-[#73786F]">Based on 12,847+ verified reviews</p>
          </div>
        </a>

        <div className="text-center">
          <a href={AFFILIATE_URL} target="_blank" rel="noopener noreferrer" data-testid="testimonials-cta">
            <Button className="bg-gradient-to-r from-[#FF6B00] to-[#FF8C00] hover:from-[#E65C00] hover:to-[#FF6B00] text-white font-black rounded-full px-10 py-5 shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1 text-lg uppercase tracking-wide">
              👉 Join 12,847+ Happy Customers
            </Button>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
